import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useI18N } from '../../context/I18NContext';
import { MenuItem, Select, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import useWidgetStore from '../../store/useWidgetStore';
import { useFormContext } from 'react-hook-form';
export default function BirthdayField(props) {
    var _a;
    const { t } = useI18N();
    const theme = useTheme();
    const [day, setDay] = useState('_');
    const [month, setMonth] = useState('_');
    const [year, setYear] = useState('_');
    const [internalErrors, setInternalErrors] = useState({
        d: false,
        m: false,
        y: false,
        any: false
    });
    const updateErrors = () => {
        var _a;
        if (((_a = errors[props.name]) === null || _a === void 0 ? void 0 : _a.type) === 'required') {
            setInternalErrors({
                d: day === '_',
                m: month === '_',
                y: year === '_',
                any: day === '_' || month === '_' || year === '_'
            });
        }
        else {
            setInternalErrors({ d: false, m: false, y: false, any: false });
        }
    };
    const { getValues, setValue, register, formState: { errors } } = useFormContext();
    useEffect(() => {
        var _a, _b, _c, _d;
        // if we have a default value
        if (getValues(props.name)) {
            let dob = ((_a = getValues(props.name)) !== null && _a !== void 0 ? _a : '_-_-_').split('-');
            setDay((_b = dob[2]) !== null && _b !== void 0 ? _b : '_');
            setMonth((_c = dob[1]) !== null && _c !== void 0 ? _c : '_');
            setYear((_d = dob[0]) !== null && _d !== void 0 ? _d : '_');
        }
    }, []);
    useEffect(() => {
        if (year && month && day) {
            if (year !== '_' && month !== '_' && day !== '_') {
                setValue(props.name, `${year}-${month}-${day}`);
            }
            else {
                setValue(props.name, undefined);
            }
        }
        updateErrors();
    }, [day, month, year]);
    const { language } = useWidgetStore();
    const onChangeDay = (event) => {
        setDay(event.target.value);
    };
    const onChangeMonth = (event) => {
        setMonth(event.target.value);
    };
    const onChangeYear = (event) => {
        setYear(event.target.value);
    };
    const optionsDay = [];
    const optionsMonth = [];
    const optionsYear = [];
    optionsDay.push({ id: '_', label: t('dag', 'register') });
    optionsMonth.push({ id: '_', label: t('maand', 'register') });
    optionsYear.push({ id: '_', label: t('jaar', 'register') });
    for (let i = 1; i <= 31; i++) {
        optionsDay.push({ id: i < 10 ? '0'.concat(i.toString()) : i.toString(), label: i.toString() });
    }
    for (let i = 1; i < 13; i++) {
        optionsMonth.push({ id: i < 10 ? '0'.concat(i.toString()) : i.toString(), label: dayjs(`2025-${i}-01`).locale(language).format('MMMM') });
    }
    for (let i = new Date().getFullYear(); i >= 1925; i--) {
        optionsYear.push({ id: i.toString(), label: i.toString() });
    }
    let label = t(props.field.label, 'register');
    if (props.field.required) {
        label = label.concat(' *');
    }
    useEffect(() => {
        updateErrors();
    }, [errors]);
    return (_jsxs(_Fragment, { children: [_jsx("input", Object.assign({ id: props.name, type: 'hidden' }, register(props.name, { required: (_a = props.field.required) !== null && _a !== void 0 ? _a : false }))), day && month && year && (_jsxs("div", { className: "\n                MuiFormControl-root \n                MuiFormControl-fullWidth\n                MuiTextField-root \n                ", style: { marginTop: '8px', marginBottom: '8px', position: 'relative' }, children: [_jsx("label", { className: "\n                MuiFormLabel-root \n                MuiInputLabel-root \n                MuiInputLabel-formControl    \n                MuiFormLabel-colorPrimary \n                MuiFormLabel-filled \n                MuiInputLabel-animated ", "data-shrink": "true", style: {
                            // transform: 'translate(14px, 22px) scale(1)',
                            position: 'absolute',
                            top: '4px',
                            left: '14px',
                            fontFamily: "'DM Sans', sans-serif",
                            fontWeight: 400,
                            fontSize: '0.95rem',
                            color: theme.palette.text.primary
                        }, children: label }), _jsxs("fieldset", { className: "MuiOutlinedInput-notchedOutline", style: {
                            borderColor: internalErrors.any
                                ? '#d32f2f'
                                : theme.palette.text.secondary,
                            borderRadius: ' 4px',
                            borderWidth: '1px',
                            backgroundColor: theme.palette.background.default,
                            margin: 0,
                            // for some reason, this stylesheet from the backend: https://onlineafspraken.mizar-it.com/themes/a2sp/css/form.css?1763974577
                            // targets all fieldsets, but somehow this only causes an issue on the BirthdayField in preview mode ( and not any other fieldset)
                            borderStyle: 'solid',
                            padding: '28px 12px 10px 12px'
                        }, children: [_jsx("legend", { style: { display: 'none' }, children: _jsx("span", { children: label }) }), _jsx(Select, { sx: {
                                    margin: '0 8px 0 0',
                                    width: '84px',
                                    borderColor: theme.palette.text.secondary,
                                    backgroundColor: theme.palette.background.default,
                                    "& fieldset": {
                                        borderColor: theme.palette.text.secondary
                                    },
                                    "& .Mui-focused": {
                                        borderColor: theme.palette.primary.main,
                                        color: `${theme.palette.text.primary} !important`
                                    },
                                    "& label": {
                                        color: theme.palette.text.primary
                                    },
                                    "& svg": {
                                        color: theme.palette.text.secondary
                                    },
                                    "& .MuiInputBase-formControl": {
                                        backgroundColor: theme.palette.background.default,
                                    },
                                    "& .MuiSelect-select": {
                                        padding: '10px 14px 10px 14px'
                                    },
                                    "&.Mui-error .MuiSelect-select": {
                                        color: '#d32f2f'
                                    }
                                }, className: internalErrors.d ? 'Mui-error' : '', id: props.name.concat('-d'), label: '', value: day, onChange: onChangeDay, children: optionsDay.map((option, index) => {
                                    return (_jsx(MenuItem, { value: option.id, children: option.label }, index));
                                }) }), _jsx("span", { style: { lineHeight: '44px' }, children: "-" }), _jsx(Select, { sx: {
                                    margin: '0 8px',
                                    width: 'calc(100% - 228px )',
                                    borderColor: theme.palette.text.secondary,
                                    backgroundColor: theme.palette.background.default,
                                    "& fieldset": {
                                        borderColor: theme.palette.text.secondary
                                    },
                                    "& .Mui-focused": {
                                        borderColor: theme.palette.primary.main,
                                        color: `${theme.palette.text.primary} !important`
                                    },
                                    "& label": {
                                        color: theme.palette.text.primary
                                    },
                                    "& svg": {
                                        color: theme.palette.text.secondary
                                    },
                                    "& .MuiInputBase-formControl": {
                                        backgroundColor: theme.palette.background.default,
                                    },
                                    "& .MuiSelect-select": {
                                        padding: '10px 14px 10px 14px'
                                    },
                                    "&.Mui-error .MuiSelect-select": {
                                        color: '#d32f2f'
                                    }
                                }, className: internalErrors.m ? 'Mui-error' : '', id: props.name.concat('-m'), label: '', value: month, onChange: onChangeMonth, children: optionsMonth.map((option, index) => {
                                    return (_jsx(MenuItem, { value: option.id, children: option.label }, index));
                                }) }), _jsx("span", { style: { lineHeight: '44px' }, children: "-" }), _jsx(Select, { sx: {
                                    margin: '0 0 0 8px',
                                    width: '100px',
                                    borderColor: theme.palette.text.secondary,
                                    backgroundColor: theme.palette.background.default,
                                    "& fieldset": {
                                        borderColor: theme.palette.text.secondary
                                    },
                                    "& .Mui-focused": {
                                        borderColor: theme.palette.primary.main,
                                        color: `${theme.palette.text.primary} !important`
                                    },
                                    "& label": {
                                        color: theme.palette.text.primary
                                    },
                                    "& svg": {
                                        color: theme.palette.text.secondary
                                    },
                                    "& .MuiInputBase-formControl": {
                                        backgroundColor: theme.palette.background.default,
                                    },
                                    "& .MuiSelect-select": {
                                        padding: '10px 14px 10px 14px'
                                    },
                                    "&.Mui-error .MuiSelect-select": {
                                        color: '#d32f2f'
                                    }
                                }, className: internalErrors.y ? 'Mui-error' : '', id: props.name.concat('-y'), label: '', value: year, onChange: onChangeYear, children: optionsYear.map((option, index) => {
                                    return (_jsx(MenuItem, { value: option.id, children: option.label }, index));
                                }) })] })] }))] }));
}
